import * as React from "react"
import {
  useSsrLogsQuery,
  useSsrLogCreatedSubscription,
  SsrLogsDocument,
  SsrLogsQuery,
  SsrLogsQueryVariables,
} from "@modules/build/logs/ssr/queries.generated"

export function useBuildSrrLogs(
  buildId: string,
  siteId: string,
  setRecentDynamicallyAddedLogId: (id: number) => void
) {
  const [seeRecentLogs, setSeeRecentLogs] = React.useState(false)
  const { data, loading, error } = useSsrLogsQuery({
    variables: {
      buildId,
      siteId,
    },
    fetchPolicy: `cache-and-network`,
  })

  useSsrLogCreatedSubscription({
    variables: {
      buildId,
      siteId,
    },
    onSubscriptionData: ({ client, subscriptionData }) => {
      const queryInfo = {
        query: SsrLogsDocument,
        variables: {
          buildId,
          siteId,
        },
      }

      try {
        const currentLogs = client.readQuery<
          SsrLogsQuery,
          SsrLogsQueryVariables
        >(queryInfo)

        if (!currentLogs) {
          return
        }

        const currentSrrLogs = currentLogs?.ssrLogs || []
        const logsPayload = subscriptionData?.data?.ssrLogCreated

        if (logsPayload) {
          currentLogs.ssrLogs = [logsPayload, ...currentSrrLogs]

          client.writeQuery<SsrLogsQuery, SsrLogsQueryVariables>({
            ...queryInfo,
            data: currentLogs,
          })

          setRecentDynamicallyAddedLogId(logsPayload.id)

          //  show the announcment badge only if the content of the page is scrolled down,
          //  the `500px` values is picked manually
          if (window.pageYOffset > 500 && !seeRecentLogs) {
            setSeeRecentLogs(true)
          }
        }
      } catch (e) {
        console.error(e)
      }
    },
  })

  const buildSrrLogs = data?.ssrLogs || []

  return [
    buildSrrLogs,
    { error, loading, seeRecentLogs, setSeeRecentLogs },
  ] as const
}
